<style scoped>
  .asset-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .asset-cards {
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 16px;
  }

  .bold1 {
    font-weight: bold;
  }

  .actbtns {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .actbtn:hover {
    cursor: pointer;
    font-weight: bold;
  }

  .btn-disabled {
    opacity: 0.2;
  }

  .row:hover {
    background-color: #020101;
    cursor: pointer;
  }

  .free-balance-text {
    font-size: 11px;
    color: var(--color-text-dark);
    font-weight: bold;
  }

  .value-cell {
    text-align: right;
  }

  .cont1 {
    display: flex;
  }

  .amount-percent {
    font-size: 12px;
    cursor: pointer;
    padding-left: 10px;
    /*color: #8f92cd;*/
    color: var(--color-neutral);
  }

  .amount-percent:hover {
    text-decoration: underline;
  }

  .err-cell {
    height: 15px;
    text-align: left;
    padding-left: 2px;
    font-size: 12px;
    color:var(--color-danger-light);
  }

  a:hover {
    text-decoration: underline;
  }

  td {
    /*border: 1px solid mediumturquoise;*/
  }

  div {
    /*border: 1px solid mediumturquoise;*/
  }

</style>
<template>
  <div>
    <FastbotAddExhangeModal @on-cancel="fbotdata.showAddExchangeModal = false"/>
    <div class="newbox" style="text-align: left; font-size: 14px;">
      <div class="cont1">
        <div>
          <Select v-if="!fbotdata.selected"  style="width:145px;"  :value="symbol" size="large" filterable
                  @click.native="cl" @on-change="symbolChange($event)" placement="top">
            <Option v-for="symbol in fbotdata.symbols" :value="symbol.baseAsset + '/' + symbol.quoteAsset" :key="symbol.baseAsset + '/' + symbol.quoteAsset">{{ symbol.baseAsset + '/' + symbol.quoteAsset }}</Option>
          </Select>
          <div v-else>
            <div class="asset-wrapper">
              <CoinIcon :symbol="fbotdata.selected.Asset" />
              <span style="font-size: 18px; color: var(--color-text-light);">{{ fbotdata.selected.Asset }}</span>
            </div>
            <div style="font-size: 12px; color: var(--color-text-dark); cursor: pointer" @click="$copyToClipboardAndNotify(fbotdata.selected.Id)">#{{ fbotdata.selected.Id }}</div>
          </div>
        </div>
        <div class="value-cell" style="flex: 1; align-self: center">
          <div class="free-balance-text">{{ $text.tr('ДОСТУПНО') }}</div>
          <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ balance }} USDT</div></div>
        </div>
      </div>
      <table style="width: 100%; border-collapse: collapse; border-spacing: 0px;">
        <tr style="height: 50px">
          <td style="width: 180px; color: var(--color-text-dark);">{{ $text.tr('ПЛЕЧО') }}</td>
          <td>
            <Slider size="large"
              v-model="leverage"
              :min="2"
              :max="50"
              :step="1"
              show-tip="never"
              v-if="fbotdata.selected === undefined"></Slider>
          </td>
          <td style="width: 50px; font-size: 22px; text-align: right;">{{ leverage }}X</td>
        </tr>
        <tr>
          <td style="width: 180px; color: var(--color-text-dark);">
            {{ $text.tr('СУММА ИНВЕСТИЦИЙ') }}
            <div v-if="!fbotdata.selected">
              <span class="amount-percent" style="padding: 0px" @click="percentFromAmount(10)">10%</span>
              <span class="amount-percent" @click="percentFromAmount(25)">25%</span>
              <span class="amount-percent" @click="percentFromAmount(50)">50%</span>
              <span class="amount-percent" @click="percentFromAmount(100)">100%</span>
            </div>
          </td>
          <td colspan="2">
            <i-input v-model="amount" size="large" :disabled="fbotdata.selected != undefined">
              <span slot="append"><div class="input">USDT</div></span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td></td>
          <td colspan="2">
            <div class="err-cell">
              {{ amountErr }}
            </div>
          </td>
        </tr>
      </table>
      <div v-if="fbotdata.exchTokenId !== ''" class="actbtns" style="width: 100%; margin-top: 40px; font-size: 20px; display: flex; justify-content: space-evenly">
        <div v-if="!isUpDisabled">
          <img v-if="!waiting" :src="upimg" width="150px"  style="cursor: pointer;" @click="flipFastbot('UP')" @mouseover="uphover = true" @mouseleave="uphover = false">
          <img v-else :src="upimg" width="150px"  style="opacity: 0.5">
        </div>
        <div v-if="!isDownDisabled">
          <img v-if="!waiting" :src="downimg" width="150px" style="cursor: pointer" @click="flipFastbot('DOWN')" @mouseover="downhover = true" @mouseleave="downhover = false">
          <img v-else :src="downimg" width="150px" style="opacity: 0.5">
        </div>
        <div v-if="!isStopDisabled" style="height: 40px;">
          <img v-if="!waiting" :src="stopimg" width="40px" style="cursor: pointer" @click="stopFastbot" @mouseover="stophover = true" @mouseleave="stophover = false">
          <img v-else :src="stopimg" width="40px" style=" opacity: 0.5">
        </div>
      </div>
      <div v-else-if="fbotdata.exchTokenLoaded" style="padding-top: 60px; padding-right:  20px; padding-left: 20px">
        <Button size="default" long style="width: 100%;" @click="showAddExchangeModal">
          <div>{{ $text.tr('ПОДКЛЮЧИТЬ BINANCE FUTURES') }}</div>
        </Button>
<!--        <div style="font-size: 16px; margin-top: 20px; border-bottom: 1px solid #6b74e7; font-weight: bold">Открыт ранний доступ для реферальных пользователей</div>-->
        <div style="font-size: 16px;">
          <div style="margin-top: 20px; font-weight: bold; border-left: 1px solid #6b74e7; padding-left: 10px">
            {{ $text.tr('Зарегистрируйтесь на Binance Futures') }}<br>{{ $text.tr('по ссылке и торгуйте без оплаты подписки') }} <a href="https://www.binance.com/ru/futures/ref/capico" target="_blank" style="color: #6b74e7;">https://www.binance.com/ru/futures/ref/capico</a>
          </div>
<!--          <div style="margin-top: 20px">-->
<!--            <li>получите <span style="font-weight: bold;">бесплатный доступ</span> ко всем инструментам платформы</li>-->
<!--            <li><span style="font-weight: bold;">скидку 10%</span> на комиссию биржи в течение месяца</li>-->
<!--          </div>-->
        </div>
      </div>
      <div v-if="!isUpDisabled && !isDownDisabled" style="font-size: 14px; margin-top: 50px; font-weight: bold">{{ $text.tr('Внимание: При запуске Бустера вы измените плечо на указанное по всем выставленным ордерам по этой паре.') }}<br>{{ $text.tr('Будет использован тип маржи, который выбран в Терминале для данной пары.') }}<br><a style="color: var(--color-accent-dark)" target="_blank" :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')">{{ $text.tr('Подробнее') }}</a></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { FastbotData, Fastbot } from '@/util/types'
// @ts-ignore
import SlimApi from '@/util/slimapi'
import Util from '@/util/util'
import fastbot from '@/services/fastbot'
import Decimal from 'decimal.js'
import FastbotAddExhangeModal from '@/components/MainPage/Fastbot/FastbotAddExhangeModal.vue'
import CoinIcon from '@/components/common/CoinIcon.vue'

@Component({
  components: {
    FastbotAddExhangeModal,
    CoinIcon
  }
})
export default class FastbotPanel extends Vue {
  assets: string[] = ['BTC', 'ETH']
  active = 0
  amount = '0'
  leverage = 2
  balance = '0'
  symbol = ''
  waiting = false
  downhover = false
  uphover = false
  stophover = false
  amountErr = ''

  get fbotdata () {
    // @ts-ignore
    return (this.$store.state.fastbot as FastbotData)
  }

  get isUpDisabled (): boolean {
    return (this.fbotdata.selected !== undefined && this.fbotdata.selected.Stage === 'UP') || (this.fbotdata.selected !== undefined && this.fbotdata.selected.Status === 'HIST')
  }

  get isDownDisabled (): boolean {
    return (this.fbotdata.selected !== undefined && this.fbotdata.selected.Stage === 'DOWN') || (this.fbotdata.selected !== undefined && this.fbotdata.selected.Status === 'HIST')
  }

  get isStopDisabled (): boolean {
    return this.fbotdata.selected === undefined || (this.fbotdata.selected !== undefined && this.fbotdata.selected.Status === 'HIST')
  }

  get downimg (): string {
    if (this.downhover) {
      return require('../../../assets/down-hover.png')
    } else {
      return require('../../../assets/down.png')
    }
  }

  get upimg (): string {
    if (this.uphover) {
      return require('../../../assets/up-hover.png')
    } else {
      return require('../../../assets/up.png')
    }
  }

  get stopimg (): string {
    if (this.stophover) {
      return require('../../../assets/stop-hover.png')
    } else {
      return require('../../../assets/stop.png')
    }
  }

  @Watch('amount')
  amountChanged () {
    this.checkErrors()
  }

  @Watch('leverage')
  leverageChanged () {
    this.checkErrors()
  }

  @Watch('fbotdata.selected')
  changed (newFbot: Fastbot) {
    if (!newFbot) {
      this.symbol = this.fbotdata.asset + '/USDT'
      this.updateBalanceAndCheckErrors()
      return
    }
    this.amount = parseFloat(newFbot.Amount).toFixed(2).toString()
    this.leverage = newFbot.Leverage
  }

  @Watch('$route')
  routeChanged (to: any, from: any) {
    // console.log('route:', to)
    if (to.name === 'fastbot') {
      fastbot.updateFastbotBalance()
    }
  }

  @Watch('fbotdata.exchTokenId')
  exchTokenUpdated () {
    fastbot.updateFastbotSymbols()
    fastbot.updateFastbotBalance()
  }

  @Watch('fbotdata.freeBal')
  balanceUpdated (freeBal: string) {
    if (!freeBal || freeBal === '') {
      return
    }
    this.balance = new Decimal(freeBal).toDecimalPlaces(2).toString()
    const newQty = new Decimal(this.balance).div(100).mul(50)
    this.amount = newQty.toDP(2).toString()
  }

  @Watch('fbotdata.symbols')
  symbolsUpdated (symbols: any[]) {
    if (symbols.length > 0 && this.symbol === '' && this.fbotdata.asset !== '') {
      this.symbol = this.fbotdata.asset + '/USDT'
    }
  }

  checkErrors () {
    if (this.fbotdata.selected) {
      this.amountErr = ''
      return
    }
    const symb = this.symbol.replace('/', '_')
    const filt = this.fbotdata.symbolsfilter[symb]
    if (!filt) {
      return
    }
    const amountMin = new Decimal(filt.QtyMin).mul(this.fbotdata.markPrice).toDP(2)
    const amountMinGivenLeverage = amountMin.div(this.leverage).toDP(2)

    if (this.amount === '') {
      // @ts-ignore
      this.amountErr = this.$text.tr('Минимальная сумма: ') + ' ' + amountMinGivenLeverage
      return
    }

    const amountTot = new Decimal(this.leverage).mul(this.amount)
    if (new Decimal(this.amount).greaterThan(this.balance)) {
      // @ts-ignore
      this.amountErr = this.$text.tr('Недостаточно средств')
    } else if (amountTot.lessThan(amountMin)) {
      // @ts-ignore
      this.amountErr = this.$text.tr('Минимальная сумма: ') + ' ' + amountMinGivenLeverage
    } else {
      this.amountErr = ''
    }
  }

  showAddExchangeModal () {
    this.fbotdata.showAddExchangeModal = true
  }

  startFastbot (stage: string) {
    const params = {
      params: {
        // @ts-ignore
        token: this.$store.state.sys.token,
        etid: this.fbotdata.exchTokenId,
        asset: this.fbotdata.asset,
        stage,
        amount: this.amount,
        leverage: this.leverage
      }
    }
    // console.log('startFastbot', params)
    const ref = this
    SlimApi.get('fastbot/start', params)
      .then((response: any) => {
        this.waiting = false
        // console.log('startFastbot:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            this.fbotdata.selected = response.data
            fastbot.updateFastbotBalance()
            this.fbotdata.type = 'ACT'
          } else {
            if (response.data.err === 'request error: Order\'s position side does not match user\'s setting.') {
              // @ts-ignore
              ref.$Notice.error({
                // @ts-ignore
                title: ref.$text.tr('Ошибка'),
                // @ts-ignore
                desc: ref.$text.tr('HedgeError'),
                duration: 15
              })
              return
            }
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
        fastbot.updateList()
        fastbot.getFastbotExcOrders()
      }).catch((error: any) => {
        this.waiting = false
        // error
        console.log(error)
        // @ts-ignore
        ref.$Notice.error({
          // @ts-ignore
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
  }

  stopFastbot () {
    if (this.isStopDisabled || this.fbotdata.selected === undefined || this.waiting) {
      return
    }
    this.stophover = false
    this.waiting = true
    const params = {
      params: {
        // @ts-ignore
        token: this.$store.state.sys.token,
        etid: this.fbotdata.exchTokenId,
        fbot_id: this.fbotdata.selected.Id
      }
    }
    // console.log('stopFastbot', params)
    SlimApi.get('fastbot/stop', params)
      .then((response: any) => {
        // console.log('stopFastbot:', response.data)
        this.waiting = false
        if (response.data !== null) {
          if (!response.data.err) {
            this.fbotdata.selected = undefined
            fastbot.getFastbotExcOrders()
            fastbot.updateFastbotBalance()
            fastbot.updateList()
          } else {
            if (response.data.err === 'request error: Order\'s position side does not match user\'s setting.') {
              // @ts-ignore
              this.$Notice.error({
                // @ts-ignore
                title: this.$text.tr('Ошибка'),
                // @ts-ignore
                desc: this.$text.tr('HedgeError'),
                duration: 15
              })
              return
            }
            // @ts-ignore
            this.$Notice.error({
              // @ts-ignore
              title: this.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      }).catch((error: any) => {
      // error
        this.waiting = false
        console.log(error)
        // @ts-ignore
        this.$Notice.error({
          // @ts-ignore
          title: this.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
  }

  flipFastbot (stage: string) {
    if (this.waiting || this.amountErr !== '') {
      return
    }
    this.waiting = true
    this.downhover = false
    this.uphover = false
    if (this.fbotdata.selected) {
      const params = {
        params: {
          // @ts-ignore
          token: this.$store.state.sys.token,
          etid: this.fbotdata.exchTokenId,
          fbot_id: this.fbotdata.selected.Id,
          dir: stage
        }
      }
      // console.log('flip', params)
      SlimApi.get('fastbot/flip', params)
        .then((response: any) => {
          this.waiting = false
          // console.log('flip:', response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              fastbot.getFastbotExcOrders()
              fastbot.updateFastbotBalance()
              fastbot.updateList()
            } else {
              if (response.data.err === 'request error: Order\'s position side does not match user\'s setting.') {
                // let desc = this.$text.tr('Переключитесь в режим хеджирования на бирже. <a style="color: var(--color-info); margin-left: 5px" href="https://capico.app/info/p/9beff7da-60cc-4374-87a5-72aaebc6620a/" target="_blank">ИНСТРУКЦИЯ</a>')

                // @ts-ignore
                this.$Notice.error({
                  // @ts-ignore
                  title: this.$text.tr('Ошибка'),
                  // @ts-ignore
                  desc: this.$text.tr('HedgeError'),
                  duration: 15
                })
                return
              }
              // @ts-ignore
              this.$Notice.error({
                // @ts-ignore
                title: this.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        }).catch((error: any) => {
          console.log(error)
          this.waiting = false
          // @ts-ignore
          this.$Notice.error({
            // @ts-ignore
            title: this.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    } else {
      this.startFastbot(stage)
    }
  }

  symbolChange (event: string) {
    if (event) {
      this.symbol = event
      fastbot.setFastbotAsset(this.symbol.split('/')[0])
      // console.log('asset changed to:' + this.fbotdata.asset)
    }
    this.updateBalanceAndCheckErrors()
  }

  async updateBalanceAndCheckErrors () {
    await fastbot.updateFastbotBalance()
    this.checkErrors()
  }

  cl (e: any) {
    if (e.target.className === 'ivu-select-input') {
      e.target.select()
    }
  }

  percentFromAmount (percent: number) {
    if (percent === 100) {
      this.amount = this.balance.toString()
      return
    }
    const newQty = new Decimal(this.balance).div(100).mul(percent)
    this.amount = newQty.toDecimalPlaces(2).toString()
  }
}
</script>
